// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'notepad-empty';

export const Component = () => (
  <path d='M19.182 1.963h-1.437V.48c0-.335-.191-.479-.526-.479s-.48.144-.48.479v1.484h-3.927V.48c0-.335-.143-.479-.478-.479-.336 0-.48.144-.48.479v1.484H7.928V.48C7.927.144 7.784 0 7.448 0c-.335 0-.526.144-.526.479v1.484H5.485c-.431 0-.766.144-1.054.432A1.408 1.408 0 0 0 4 3.448v19.589c0 .431.144.766.431 1.054.288.287.623.43 1.054.43h13.698a1.41 1.41 0 0 0 1.054-.43c.287-.288.431-.623.431-1.054V3.448c0-.43-.144-.766-.431-1.053a1.408 1.408 0 0 0-1.054-.432h-.001Zm.527 3.928v17.145c0 .335-.192.479-.527.479H5.484c-.335 0-.526-.144-.526-.48V5.892h14.75Zm0-2.443v1.437H4.958V3.448c0-.335.191-.526.526-.526h13.698c.335 0 .527.191.527.526Z' />
);

export const viewBox = '0 0 25 25';
